const feefoInit = () => {
  const body = document.getElementsByTagName('body')[0]
  const merchantId = body.dataset.merchant

  if (!merchantId) return
  ;(function (w) {
    var feefoWidgetScript = document.createElement('script')
    feefoWidgetScript.setAttribute('async', 'async')
    feefoWidgetScript.setAttribute('src', '//register.feefo.com//feefo-widget-v2/js/feefo-widget.js')
    feefoWidgetScript.setAttribute('type', 'text/javascript')
    feefoWidgetScript.onload = function () {
      if (typeof w.feefoWidgetInstance === 'undefined') {
        if (typeof feefoWidget !== 'undefined') {
          w.feefoWidgetInstance = feefoWidget(w.feefoWidgetInstanceConfig)
        }
      }
    }
    w.feefoWidgetInstanceConfig = {
      assetUrl: '//register.feefo.com//feefo-widget-v2',
      debug: false,
      hosts: {
        api: 'api.feefo.com/api',
        widget: 'register.feefo.com',
        collector: 'collect.feefo.com',
      },
      merchantId: merchantId,
      protocol: 'https',
      source: 'javascript',
      tags: '',
      externalCta: '',
      versionDir: 'feefo-widget-v2',
      isMigratedMerchant: 'false',
    }
    w.FeefoWidgetSources = {
      onPage: 'LEGACY',
      slideOut: 'LEGACY',
      popupReviews: 'LEGACY',
      productStars: 'LEGACY',
      optionalProductStars: 'LEGACY',
      mediaGallery: 'LEGACY',
      serviceCarousel: 'LEGACY',
      questionDisplay: 'LEGACY',
      questionForm: 'LEGACY',
      aaeBadge: 'LEGACY',
      highlightedTopics: 'LEGACY',
      highlightedSnippets: 'LEGACY',
    }
    document.head.appendChild(feefoWidgetScript)
    var widgetsAppEnabled = false
    if (widgetsAppEnabled) {
      var feefoWidgetsAppScript = document.createElement('script')
      feefoWidgetsAppScript.setAttribute('async', 'async')
      feefoWidgetsAppScript.setAttribute('src', `https://api.feefo.com/feefo-widgets-data/loader/widgets/${merchantId}`)
      feefoWidgetsAppScript.setAttribute('type', 'text/javascript')
      document.head.appendChild(feefoWidgetsAppScript)
    }
  })(window)
}

export default feefoInit
